export const checkAPIResponse = (result) => {
  // Handle case when result is null/undefined
  if (!result) {
    const error = new Error('API response is null or undefined');
    error.isAPIError = true;
    throw error;
  }

  // Handle case when result has a direct error message (no updatePackage)
  if (!result.updatePackage && result.message) {
    const error = new Error(result.message);
    error.isAPIError = true;
    throw error;
  }

  // Handle case when updatePackage exists but is null/undefined
  if (result.updatePackage === null || result.updatePackage === undefined) {
    const errorMessage = result.message || 'updatePackage is null or undefined';
    const error = new Error(errorMessage);
    error.isAPIError = true;
    throw error;
  }

  // Try to parse updatePackage if it exists
  if (result.updatePackage) {
    try {
      const updatePackage = JSON.parse(result.updatePackage);
      
      // Check if updatePackage is valid and has Table
      if (updatePackage && updatePackage.Table && updatePackage.Table.length > 0) {
        const tableResponse = updatePackage.Table[0];
        const fnErrCode = tableResponse?.FnErrCode ? Number(tableResponse.FnErrCode) : null;
        
        // Check for business logic errors
        const isError = fnErrCode && fnErrCode !== -1 && fnErrCode !== 0;
        
        if (isError) {
          const errorMessage = tableResponse.ErrMsg || 'An error occurred while processing the request';
          console.error('API returned business logic error:', {
            FnErrCode: tableResponse.FnErrCode,
            ErrMsg: tableResponse.ErrMsg
          });
          const error = new Error(errorMessage);
          error.isBusinessLogicError = true;
          error.errorCode = tableResponse.FnErrCode;
          throw error;
        }
      } else {
        // updatePackage parsed successfully but doesn't have expected structure
        const errorMessage = result.message || 'Invalid updatePackage structure - missing Table data';
        const error = new Error(errorMessage);
        error.isStructureError = true;
        throw error;
      }
    } catch (parseError) {
      // Re-throw business logic errors
      if (parseError.isBusinessLogicError || parseError.isStructureError) {
        throw parseError;
      }
      
      // Handle JSON parsing errors
      console.warn('Could not parse updatePackage:', parseError);
      const errorMessage = result.message || 'Failed to parse API response';
      const error = new Error(errorMessage);
      error.isParseError = true;
      error.originalError = parseError;
      throw error;
    }
  }

  // If we reach here, the response is considered valid
  return true;
};